var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1750_2909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.091 0H2.90912C1.30541 0 0 1.30466 0 2.90912V29.091C0 30.6953 1.30541 32.0001 2.90912 32.0001H29.091C30.6947 32.0001 32.0001 30.6954 32.0001 29.091V2.90912C32 1.30466 30.6947 0 29.091 0ZM23.0595 21.0029C23.3436 21.2869 23.3436 21.7474 23.0595 22.0315L22.0313 23.0598C21.7472 23.3438 21.2868 23.3438 21.0027 23.0598L15.9999 18.057L10.9971 23.0598C10.713 23.3438 10.2526 23.3438 9.96853 23.0598L8.94028 22.0315C8.65616 21.7475 8.65616 21.287 8.94028 21.0029L13.9431 16.0001L8.94028 10.9973C8.65616 10.7133 8.65616 10.2528 8.94028 9.9688L9.96853 8.94048C10.2526 8.65651 10.713 8.65651 10.9971 8.94048L15.9999 13.9433L21.0027 8.94048C21.2868 8.65651 21.7472 8.65651 22.0313 8.94048L23.0595 9.9688C23.3436 10.2528 23.3436 10.7133 23.0595 10.9973L18.0567 16.0001L23.0595 21.0029Z",
    fill: "#4F565E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1750_2909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x-mark.b252212177e2abd8ba881f59e0382570.svg";
export { ForwardRef as ReactComponent };